import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import endpoints from "../../config/endpoints";
import { Sidebar } from "../../layouts/Sidebar";
import { setLoading } from "../../services/reducers/homeSlice";
import restApi from "../../services/restApi";
import RichTextEditor, {
  EDITOR_UPLOAD_PENDING_MESSAGE,
  editorUploadsPending,
} from "../../components/RichTextEditor";
import tools from "../../utils/tools";

const TagManage = () => {
  const { id: paramId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form, setForm] = useState<any>({});
  const [image, setImage] = useState<any>({});

  const send = async () => {
    // an editor image still uploading would be saved without its address
    if (editorUploadsPending()) {
      Swal.fire({
        title: "صبر کنید",
        text: EDITOR_UPLOAD_PENDING_MESSAGE,
        icon: "warning",
        confirmButtonText: "متوجه شدم",
      });
      return;
    }
    dispatch(setLoading(true));

    const tagResult = await restApi(
      endpoints.tag.basic + (paramId || ""),
      true,
    ).post(tools.extractor(form, ["title", "description"]));

    if (tagResult.code == 200) {
      if (image.data) {
        const formData = new FormData();
        formData.append("file", image.data);
        await restApi(endpoints.tag.medias + tagResult.data.id, true).upload(formData);
      }
      Swal.fire({
        title: "موفق",
        text: `تگ با موفقیت ${paramId ? "ویرایش" : "ایجاد"} شد`,
        icon: "success",
        confirmButtonText: "متوجه شدم",
        didClose() {
          navigate("/tag");
        },
      });
    } else {
      Swal.fire({
        title: "ناموفق",
        text: tagResult?.data,
        icon: "error",
        confirmButtonText: "متوجه شدم",
      });
    }

    dispatch(setLoading(false));
  };

  const fetchItem = async () => {
    if (!paramId) return;

    dispatch(setLoading(true));

    const res = await restApi(endpoints.tag.single + paramId, true).get();
    if (res.code == 200) {
      setForm({
        title: res.data?.title,
        description: res.data?.description,
      });
      setImage({
        data: undefined,
        preview: res.data.media?.url,
      });
    }

    dispatch(setLoading(false));
  };

  useEffect(() => {
    fetchItem();
  }, []);

  return (
    <>
      <body className="dashboardBody">
        <Sidebar />
        <main className="dashBoardMain main">
          <div className="addInfoHeader">
            <span className="dashboardHeader keepRight clickable" onClick={send}>
              {paramId ? "ویرایش " : "ایجاد "}تگ
            </span>
            <span>
              <h1 className="sideBarTitle">بازگشت به صفحه تگ ها</h1>
              <h1 className="dashBoardTitle">
                {paramId ? "ویرایش" : "ایجاد"} تگ
              </h1>
            </span>
            <i className="backAdd clickable" onClick={() => navigate("/tag/")}></i>
          </div>
          <section className="bottomSection">
            <h1 className="dashBoardTitle">اطلاعات تگ</h1>
            <form className="addInfo">
              <label className="sideBarTitle" htmlFor="infoTitle">عنوان</label>
              <input
                className="addInput"
                id="infoTitle"
                onChange={(input: any) =>
                  setForm((prev) => ({ ...prev, title: input.target.value }))
                }
                value={form.title || ""}
              />
              <label className="sideBarTitle" htmlFor="infoAmount">توضیحات</label>
              <RichTextEditor
                value={form.description}
                onChange={(description) =>
                  setForm((prev) => ({ ...prev, description }))
                }
              />
              <input
                type="file"
                onChange={(input) =>
                  setImage({
                    data: input.target.files[0],
                    preview: URL.createObjectURL(input.target.files[0]),
                  })
                }
              />
            </form>
            <img src={image.preview} alt="تصویر" />
          </section>
        </main>
      </body>
    </>
  );
};
export default TagManage;
